import { ACTIONS } from 'actions/milestone-creation';

const initialState = false;

export default function defaultExport(
  state = initialState,
  action: { type: string; payload: boolean },
) {
  switch (action.type) {
    case ACTIONS.SET_MILESTONE_CREATION: {
      return action.payload;
    }
    case ACTIONS.CLEAR_MILESTONE_CREATION: {
      return initialState;
    }
    default:
      return state;
  }
}
